import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import marketplaceService, { SellerReviewOverview } from '../../../services/marketplaceService';
import StarRating from '../Reviews/StarRating';
import '../marketplace-design.css';

const formatDate = (iso: string): string => new Date(iso).toLocaleDateString('de-DE');

/**
 * Bewertungsübersicht im Seller-Dashboard (T10): die neuesten sichtbaren Bewertungen der
 * eigenen Angebote, nur lesend (Antworten laufen am Angebot selbst). Ein Ladefehler blendet
 * den Block still aus — die KPIs der Übersicht bleiben davon unberührt.
 */
const SellerReviewsList: React.FC = () => {
    const translate = useTranslate();
    const [data, setData] = useState<SellerReviewOverview | null>(null);

    useEffect(() => {
        let active = true;
        Promise.resolve(marketplaceService.getSellerReviews())
            .then((result) => active && result && Array.isArray(result.reviews) && setData(result))
            .catch(() => undefined);
        return () => {
            active = false;
        };
    }, []);

    if (!data) return null;

    return (
        <div style={{ minWidth: 0 }} data-testid="seller-reviews">
            <div className="mk-sec-t">
                <div>
                    <h2>{translate('marketplaceSeller.overview.reviews.title')}</h2>
                    <p>
                        {data.count > 0
                            ? translate('marketplaceSeller.overview.reviews.summary', { count: data.count, average: data.average ?? '–' })
                            : translate('marketplaceSeller.overview.reviews.empty')}
                    </p>
                </div>
            </div>
            <div className="mk-rev">
                {data.reviews.slice(0, 10).map((r) => (
                    <div key={r.id} className="mk-revc">
                        <div className="t">
                            <b>{r.listingTitle}</b>
                            <StarRating value={r.rating} size={18} />
                        </div>
                        <div className="who">
                            {r.reviewerName ?? '–'} · {formatDate(r.createdAt)}
                        </div>
                        {(r.title || r.body) && (
                            <p className="q">
                                {r.title && <b>{r.title}</b>}
                                {r.body}
                            </p>
                        )}
                        {r.sellerReply && (
                            <p className="reply">
                                {translate('marketplaceSeller.overview.reviews.reply')}: {r.sellerReply}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SellerReviewsList;
